import CalendarVM from './calendar-vm';
export default {
  init(node) {
    let eventsData = JSON.parse($('#js-event-data').val());
    let vm = new CalendarVM(eventsData);
    ko.applyBindingsWithValidation(vm, node, Kadenze.DEFAULT_VALIDATION_OPTIONS);
  }
};

